import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const IntegratedRewardsTable = ({ 
    dashboards,
    setSelectedItem,
    setSelectedItemName,
    loading,
    editOnClick,
    previewOnClick,
    createOnClick,
    deleteOnClick 
}) => {
    const columns = [
            {
                minWidth: 30,
                maxWidth: 30,
                onRender: (item) => (
                    <ContextualMenu
                        editOnClick={editOnClick}
                        previewOnClick={previewOnClick}
                        id={item.integratedRewardsDashboardId}
                        item={item}
                        deleteOnClick={deleteOnClick}
                    />
                ),
            },
            {
                name: 'ID',
                fieldName: 'integratedRewardsDashboardId',
                minWidth: 40,
                maxWidth: 40,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'CobrandID',
                fieldName: 'cobrandId',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'Cobrand Name',
                fieldName: 'cobrandName',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'Client Name',
                fieldName: 'clientName',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'Published',
                fieldName: 'isPublished',
                minWidth:80,
                maxWidth:100,
                isResizable: true,
                onRender: (item) => item.isPublished ? 'Yes' : 'No',
            },
        ];
    
        const items = dashboards ?? [];
    
        const formatLabel = (item) => {
            if (!item) {
                return "";
            }
            if (item.cobrandName) {
                return item.cobrandName;
            }
            if (item.clientName) {
                return item.clientName;
            }
            return String(item.integratedRewardsDashboardId ?? "");
        };

        const selectionHook = (items) => {
            const selected = items && items[0];
            setSelectedItem(selected && selected.integratedRewardsDashboardId);
            setSelectedItemName?.(formatLabel(selected));
        };
    
        return (
            <>
                <DetailsTable
                    items={items}
                    columns={columns}
                    selectionMode="none"
                    selectionHook={selectionHook}
                    loading={loading}
                    mainColumn={'cobrandName'}
                    style={{
                        position: 'relative',
                        height: '80vh',
                        width: '80vw',
                    }}
                    CommandBar={
                        <CommandBarButton
                            iconProps={{ iconName: 'Edit' }}
                            text="Add Integrated Rewards Custom Dashboard"
                            onClick={() => createOnClick()}
                        />
                    }
                />
                <FeatureSummary
                    label="About Integrated Rewards Dashboards"
                    summary="This table displays all integrated rewards custom dashboards for cobrands, including publish status. You can add, edit, or delete cobrand dashboards. The Integrated Rewards feature enables cobrands to manage dashboards that display rewards and incentives to users. Only cobrands with third party rewards enabled can access this feature. It appears as a section in the dashboard."
                />
            </>
        );
    };
    
    const moreIcon = { iconName: 'More' };
    
    const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
        const formatLabel = () => {
            if (!item) {
                return "";
            }
            if (item.cobrandName) {
                return item.cobrandName;
            }
            if (item.clientName) {
                return item.clientName;
            }
            return String(item.integratedRewardsDashboardId ?? "");
        };

        const menuProps = {
            items: [
                {
                    key: 'print',
                    iconProps: { iconName: 'Edit' },
                    text: 'Edit',
                    onClick: () => editOnClick(id),
                },
                {
                    key: "Delete",
                    iconProps: { iconName: "Delete" },
                    text: "Delete",
                    onClick: () => deleteOnClick(id, formatLabel()),
                },
            ],
        };
    
        return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
    };

export default IntegratedRewardsTable;
